import { Body, Link } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import { getMarketHasMarketingConsentDisclosure } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { ApiStatus } from '~/store/types/sharedTypes';
import useGoToNextStep from '../../../useGoToNextStep';

export const StartApplicationFooter = () => {
  const {
    cardApplication: { apiStatus: applicationApiStatus },
    intl: { market },
  } = useSelector((state: RootState) => state);
  const onNextStepClick = useGoToNextStep();

  const t = useTranslate();

  const applicationApiRequestInProgress = [
    applicationApiStatus.get,
    applicationApiStatus.patch,
    applicationApiStatus.post,
  ].includes(ApiStatus.Started);

  return (
    <>
      <NextButton
        label="CardApplication.Next"
        isLoading={applicationApiRequestInProgress}
        action={onNextStepClick}
      />
      {getMarketHasMarketingConsentDisclosure(market) && (
        <Body color="Text/Secondary" size="sm" display="block">
          {t('CardApplication.MarketingConsent', {
            next: t('CardApplication.Next'),
            privacyLink: (
              <a
                href={t('LinkUrls.Integrity') as string}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Link size="sm">{t('CardApplication.PrivacyLinkText')}</Link>
              </a>
            ),
          })}
        </Body>
      )}
    </>
  );
};
